import React, { useState, useRef } from "react";
import "./DropdownMenu.css";
import { checkAccess } from "../utils/apiUtils";
import { useHistory } from "react-router-dom";
import { ReactComponent as ArrowIcon } from "./icons/arrow.svg";
import { CSSTransition } from "react-transition-group";

function DropdownMenu(props) {
  const [activeMenu, setActiveMenu] = useState(props.name);
  const [menuHeight, setMenuHeight] = useState(null);
  const dropdownRef = useRef(null);

  function calcHeight(el) {
    const height = el.offsetHeight;
    setMenuHeight(height);
  }

  function DropdownItem(itemProps) {
    const outsideUrls = [
      "https://www.gstsearch.in/verify.html",
      "https://download.anydesk.com/AnyDesk.exe",
    ];

    const history = useHistory();

    const handleClick = () => {
      if (typeof itemProps.goToMenu === "string")
        return setActiveMenu(itemProps.goToMenu);

      if (itemProps.goToMenu?.children?.length > 0)
        return setActiveMenu(itemProps.goToMenu.name);

      itemProps.openState(false);

      if (outsideUrls.includes(itemProps.goToMenu.url)) {
        window.open(itemProps.goToMenu.url);
        return;
      }

      if (itemProps.goToMenu.url)
        history.push(itemProps.goToMenu.url);
    };

    if (itemProps.url) {
      let module = itemProps.url.replace("/", "").split("?")[0];
      const hasAccess =
        checkAccess(module) ||
        outsideUrls.includes(itemProps.url);

      if (!hasAccess) return null;
    }

    return (
      <a href="#" className="menu-item" onClick={handleClick}>
        {itemProps.leftIcon && (
          <span className="icon-button">{itemProps.leftIcon}</span>
        )}
        {itemProps.text}
        <span className="icon-right">{itemProps.rightIcon}</span>
      </a>
    );
  }

  return (
    <div
      className="dropdown"
      ref={dropdownRef}
      style={{ height: menuHeight }}
    >
      {/* PRIMARY MENU */}
      <CSSTransition
        in={activeMenu === props.name}
        timeout={250}
        classNames="menu-primary"
        unmountOnExit
        onEnter={calcHeight}
      >
        <div className="menu">
          {props.dropDownMenuItems?.map((item) => (
            <DropdownItem
              key={item.name}
              text={item.name}
              url={item.url}
              goToMenu={item}
              openState={props.openState}
            />
          ))}
        </div>
      </CSSTransition>

      {/* SECONDARY MENUS */}
      {props.dropDownMenuItems?.map((item) => (
        <CSSTransition
          key={item.name}
          in={activeMenu === item.name}
          timeout={250}
          classNames="menu-secondary"
          unmountOnExit
          onEnter={calcHeight}
        >
          <div className="menu">
            <DropdownItem
              goToMenu={props.name}
              text={item.name}
              leftIcon={<ArrowIcon />}
              openState={props.openState}
            />

            {item.children?.map((child) => (
              <DropdownItem
                key={child.name}
                text={child.name}
                url={child.url}
                goToMenu={child}
                openState={props.openState}
              />
            ))}
          </div>
        </CSSTransition>
      ))}
    </div>
  );
}

export default DropdownMenu;
